import LoadingComponent from './loading'
let $vm
const plugin = {
  install (Vue, options) {
    const Loading = Vue.extend(LoadingComponent)
    // 防止重复安装插件
    if (!$vm) {
      $vm = new Loading({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }
    const loading = {
      show () {
        $vm.isShow = true
      },
      hide () {
        $vm.isShow = false
      },
      status () {
        return $vm.isShow
      }
    }
    if (!Vue.$loading) {
      // 将loading挂载到Vue实例上
      Vue.$loading = loading
    }
    Vue.mixin({
      created() {
        this.$loading = Vue.$loading
      }
    })
  }
}
// 页面调用遮罩层 this.$loading.show()显示；this.$loading.hide()隐藏
export default plugin



// WEBPACK FOOTER //
// ./src/base/loading/index.js